// extracted by mini-css-extract-plugin
export default {"sliderOptions":"base-font-size-option-module__sliderOptions--UWbgo"};